/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Pit1_DInputs */

const en_to_xml_pit1_d = /** @type {(inputs: To_Xml_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single element cannot be distinguished from a one item array, so a tags element appearing once could have come from either. XML also has no number type, so 42 and "42" produce identical markup. Nothing is lost going to XML, but reconstructing the original JSON from that XML requires knowledge the document does not carry, usually a schema.`)
};

const ko_to_xml_pit1_d = /** @type {(inputs: To_Xml_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`단일 요소는 항목 하나짜리 배열과 구분할 수 없으므로, tags 요소가 한 번 나타났다면 둘 중 어느 쪽에서 왔는지 알 수 없습니다. XML에는 숫자 타입도 없으므로 42와 "42"가 동일한 마크업을 만듭니다. XML로 가면서 잃는 것은 없지만, 그 XML에서 원래 JSON을 복원하려면 문서가 담고 있지 않은 지식, 보통은 스키마가 필요합니다.`)
};

const ja_to_xml_pit1_d = /** @type {(inputs: To_Xml_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単一の要素は 1 項目の配列と区別できないので、tags 要素が 1 回現れた場合どちらから来たか分かりません。XML には数値型もないので 42 と "42" が同一のマークアップになります。XML へ行く際に失われるものはありませんが、その XML から元の JSON を復元するには、文書が持たない知識、通常はスキーマが必要です。`)
};

/**
* | output |
* | --- |
* | "A single element cannot be distinguished from a one item array, so a tags element appearing once could have come from either. XML also has no number type, so..." |
*
* @param {To_Xml_Pit1_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_pit1_d = /** @type {((inputs?: To_Xml_Pit1_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Pit1_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_pit1_d(inputs)
	if (locale === "ko") return ko_to_xml_pit1_d(inputs)
	return ja_to_xml_pit1_d(inputs)
});